import '../styles/about.css'
import React from 'react';

class About extends React.Component {
    render = () => {
        return (
            <div className="about-container">
                <div className="about-title">
                    <h2 className='Oswald uppercase'>About This Tool</h2>
                </div>
                <div className="about-text">
                    <p>The Utah Fire History Tracker is an interactive map that allows anyone to better understand the nature of past wildfire occurences in the state.</p>
                    <p>Created by Utah Forestry Fire &amp; State Lands, it is designed to be the authoritative source for mapped wildfire events in Utah. The tool enables people to explore the history of wildfire in an area of interest, and to generate a report with the timeline and map of historic wildfires in that area.</p>
                    <p>The Fire History Tracker displays all wildfires over 10 acres, dating back to 2017. The records include information about ignition locations, burn areas, dates the fires burned, and structures threatened/destroyed.</p>
                </div>
            </div>
        )
    }
}

export default About;